import { SplitFeatureFlag, ContentBlocksTreatment } from '@mb/lib/splitio';

export const gaAnalyticsContentBlocksExperiment = (cbLength = 0) => {
  dataLayer.push({
    event: 'contentblock_experiment_shown',
    experiment_name: SplitFeatureFlag.CONTENT_BLOCKS,
    experiment_version:
      cbLength === 0 ? ContentBlocksTreatment.OFF : ContentBlocksTreatment.ON,
  });
};
